/*
|--------------------------------------------------------------------------
| Views: Article 3rd Party
|--------------------------------------------------------------------------
*/

/**
 * Article 3rd Party
 * @namespace
 */
__gh__webApp.views.article3rdParty = {

	/**
	 * Post bucket laydown callbacks
	 * @param {object} bucket - bucket object
	 */
	"callbacks": function(bucket){

		var utilities		= __gh__webApp.utilities;
			utilities["3rdPartyIframes"].init();
	}
};
